import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FeatureFlagKey } from '../services/feature-flags/feature-flag.constant';
import { FeatureFlagService } from '../services/feature-flags/feature-flag.service';

@Directive({ selector: '[featureFlag]' })
export class FeatureFlagDirective implements OnInit, OnDestroy {

    @Input('featureFlag') flagName!: string | FeatureFlagKey;
    @Input('featureFlagElse') elseRef: TemplateRef<object> | null = null;

    private readonly destroy$ = new Subject<void>();

    constructor(
        private readonly templateRef: TemplateRef<object>,
        private readonly vcr: ViewContainerRef,
        private readonly featureFlagService: FeatureFlagService,
    ) {}

    ngOnInit(): void {
        this.featureFlagService.isEnabled$(this.flagName).pipe(
            takeUntil(this.destroy$)
        ).subscribe(enabled => {
            this.vcr.clear();
            if (enabled) {
                this.vcr.createEmbeddedView(this.templateRef);
            } else if (this.elseRef) {
                this.vcr.createEmbeddedView(this.elseRef);
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
